import {Layout} from "antd";
import {AppHeader} from "./AppHeader/AppHeader";
import {CSSProperties, useEffect, useState} from "react";
import {MainPage} from "../../Pages/MainPage/MainPage";
import {Routes, Route, Link, useLocation} from 'react-router-dom'
import {Auth} from "../../Pages/Auth/Auth";
import {RegisterPage} from "../../Pages/Register/RegisterPage";
import {SetRunningData} from "../../Pages/SetRunningData/SetRunningData";
import { Preloader } from "../preloader/preloader";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { Modal } from "../modal/Modal";
import { fetchError } from "../../store/app-slice/AppSlice";
import { Tabbar } from "../TabBar/Tabbar";
import { LentaPage } from "../../Pages/LentaPage/LantaPage";
import { AppHeaderSmall } from "./AppHeader/AppHeaderSmall";
import { ProfilePage } from "../../Pages/ProfilePage/ProfilePage";
import { RaitingPage } from "../../Pages/RaitingPage/RaitingPage";
import { ProfileWithoutNavi } from "../../Pages/ProfilePage/ProfileWithoutNavi";
import { PassReset } from "../../Pages/PassReset/PassResrt";
import { NotificationView } from "../../Pages/ProfilePage/NotificationView";

export const AppLayout = () => {
    const mainLayoutStyles: CSSProperties = {
        height: '100vh',
        width: '100%',
        backgroundColor: "#FFFFFF",
        paddingBottom:"20px"
    }
    const distpatch:any=useAppDispatch();
    const onLoad = useAppSelector(state=>state.appStore.isFetching);
    const error = useAppSelector(state=>state.appStore.error)
    const [isFullHeader,setIsFullHeader] = useState(true)
    const [isBottomMenu,setIsBonntmMenu]=useState(false)
    const [isMain,setIsMain] = useState(true)
    const location = useLocation();
    const bottomMenuHide = ["/comment", "/profileId", "/notification"]
     useEffect(()=>{
      if(error!=null)setTimeout(function(){distpatch(fetchError(null))}, 3000);
      switch(location.pathname){
        case "/lenta":case "/comment":case "/profile": case "/raiting":case "/profileId":case "/notification": setIsFullHeader(false); break;
        default: setIsFullHeader(true)
      }
      if(location.pathname==="/*"||location.pathname==="/lenta"){
        setIsMain(true)
      }else{
        setIsMain(false)
      }
      const savedUser = localStorage.getItem("currentUser")
      if(savedUser){
        if(bottomMenuHide.includes(location.pathname)){
            setIsBonntmMenu(false)
        }else{
            setIsBonntmMenu(true)
        }

      }else{
        setIsBonntmMenu(false)
      }
     },[error,location])
return (
    <Layout style={{display:"flex", alignItems:"center", backgroundColor:"white", overflow:"hidden", height:"100vh"}}>
        <Layout style={{backgroundColor:"white", maxWidth:"800px", paddingBottom:"70px"}}>
            <Layout style={{backgroundColor:"white", overflow:"scroll"}}>
                 {onLoad&&<Preloader/>}
                {error&&<Modal isOpen={true}>
                    <Modal.Content>
                        <div>
                            {error}
                        </div>
                    </Modal.Content>
                 </Modal>}
                {isFullHeader?<AppHeader isMaim={isMain}/>:<AppHeaderSmall isMaim={isMain}/>}
                <Layout style={{ ...mainLayoutStyles, height: '100%', paddingLeft:"16px", paddingRight:"16px", paddingTop:"0px", paddingBottom:"0px"}}>
                    <Routes>
                        <Route path={"*"} element={<MainPage/>}/>
                        <Route path={"/auth"} element={<Auth/>}/>
                        <Route path={"/register"} element={<RegisterPage/>}/>
                        <Route path={"/addresult"} element={<SetRunningData/>}/>
                        <Route path={"/lenta"} element={<LentaPage/>}/>
                        <Route path={"/profile"} element={<ProfilePage/>}/>
                        <Route path={"/raiting"} element={<RaitingPage/>}/>
                        <Route path={"/profileId"} element={<ProfileWithoutNavi/>}/>
                        <Route path={"/resetpass"} element={<PassReset/>}/>
                        <Route path={"/notification"} element={<NotificationView/>}/>
                    </Routes>
                </Layout>
            </Layout>
        </Layout>
        <Tabbar isBottomMenu={isBottomMenu}/>
    </Layout>
)
}